import { Navigate } from 'react-router-dom'
import { useAppAuth } from '@/contexts/app-auth.context'
import { Loader } from '@/components/ui/loader'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isAuthLoading } = useAppAuth()

  if (isAuthLoading) {
    return (
      <div className="h-screen overflow-hidden bg-[linear-gradient(146deg,_#d3f9ff_0%,_#a6eeeb_100%)]">
        <div className="flex min-h-screen items-center justify-center">
          <Loader text="Checking authentication..." className="text-primary" />
        </div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/sign-in" replace />
  }

  return <>{children}</>
}
